import React from 'react';

export const ChocolateIcon = () => {
  return (
    <svg
      preserveAspectRatio="xMidYMid meet"
      dataBox="355.022 242.105 321.122 139.935"
      viewBox="320 200 400 250"
      xmlns="http://www.w3.org/2000/svg"
      dataType="ugc"
      role="presentation"
      ariaHidden="true"
      width={60}
      height={40}
    >
      <g>
        <path
          d="m358.844 242.105 44.203 17.282 233.66.277 38.938-16.496-10.079 17.481 10.118 10.58-9.122 14.067 9.582 13.059-9.269 12.748s8.728 12.732 8.728 12.791c0 .059-8.435 13.48-8.435 13.48l7.854 15.403-6.614 10.574 5.319 15.769-39.82-13.953-237.443-.164-41.442 17.037 12.023-16.548-9.393-11.825 8.672-15.479s-8.612-10.671-8.674-10.671c-.062 0 10.167-15.259 10.167-15.259l-11.18-14.372L364 291.12l-6.931-18.722 10.28-9.974-8.505-20.319Z"
          fill="none"
          stroke="#ffffff"
          strokeWidth="9"
        ></path>
        <path
          d="M405.19 340.746c-16.335-6.878 252.14 39.282 211.156-55.854-105.609-9.145-217.234-16.85-211.156 55.854Z"
          fill="none"
          stroke="#ffffff"
          strokeWidth="6"
        ></path>
      </g>
    </svg>
  );
};
